<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Headphones" class="d-icon d-icon--headphones" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M6 2a4 4 0 0 0-4 4v.5h1A1.5 1.5 0 0 1 4.5 8v1.5A1.5 1.5 0 0 1 3 11h-.5A1.5 1.5 0 0 1 1 9.5V6a5 5 0 1 1 10 0v3.5A1.5 1.5 0 0 1 9.5 11H9a1.5 1.5 0 0 1-1.5-1.5V8A1.5 1.5 0 0 1 9 6.5h1V6a4 4 0 0 0-4-4Zm4 5.5H9a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-2Zm-8 2a.5.5 0 0 0 .5.5H3a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H2v2Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHeadphones',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
